export default __webpack_public_path__ + "static/media/ud_shared.df0b7f88.svg";